import React from "react";

export const SentimentAnalysis = React.lazy(
  () => import("@/features/sentiment-analysis/pages/SentimentAnalysisPage.tsx"),
);
